const getters = {
    userAuthenticated: (state, getters) => {
        return state.user;
    },
    isAuthenticated: (state, getters) => {
        return state.isAuthenticated;
    }
};

export default getters;